export const structureBreadcrumbs = (data) => {
  let result = [];
  const breadcrumbsData = data.split("->");

  for (let i = 0; i < breadcrumbsData.length; i++) {
    let breadcrumb = breadcrumbsData[i].split("^");
    let data = {
      value: breadcrumb[0].trim(),
      link: breadcrumb[1].trim(),
    };
    result.push(data);
  }
  return result;
};
